import applicationConfig, * as applicationConfigActions
  from './applicationConfig/applicationConfig.module';
import applicationData, * as applicationDataActions
  from './applicationData/applicationData.module';
import associatedAgreements, * as associatedAgreementsActions
  from './associatedAgreements/associateAgreements.module';
import customer, * as customerActions from './customer/customer.module';
import existingAutomatics, * as existingAutomaticsActions
  from './existingAutomatics/existingAutomatics.module';
import existingBanks, * as existingBanksActions
  from './existingBanks/existingBanks.module';
import shoppingCart, * as shoppingCartActions
  from './shoppingCart/shoppingCart.module';
import userProductTypes, * as userProductTypesActions
  from './productTypes/productTypes.module';
import personalInformation, * as personalInfoActions
  from './PersonalInformation/PersonalInformation.module';
import userManager, * as relationshipManagerActions
  from './manager/manager.module';
import modals, * as modalActions from './modals/modals.module';
import userFunds, * as userFundsActions from './UserFunds/UserFunds.module';
import allFunds, * as allFundsActions from './allFunds/AllFunds.module';
import RMDSetting, * as RMDactions from './RMD/RMD.module';
import StateWithholding, * as StateWithholdingActions
  from './stateWithholding/stateWithholding.module'
import RecentTransactions, * as RecentTransactionsActions
  from './recentTransactions/recentTransactions.module'
import QCDHistory, * as QCDHistoryActions from "./qcdHistory/QCDHistory.module";
import paperlessSetting, * as PaperlessActions
  from "./paperless/paperlessSetting.module";
//eslint-disable-next-line
export default {
  applicationConfig,
  applicationData,
  allFunds,
  associatedAgreements,
  customer,
  existingAutomatics,
  existingBanks,
  shoppingCart,
  userProductTypes,
  personalInformation,
  userManager,
  modals,
  userFunds,
  RMDSetting,
  StateWithholding,
  RecentTransactions,
  QCDHistory,
  paperlessSetting
};

export const moduleActions = {
  ...allFundsActions,
  ...applicationConfigActions,
  ...applicationDataActions,
  ...associatedAgreementsActions,
  ...customerActions,
  ...existingAutomaticsActions,
  ...existingBanksActions,
  ...shoppingCartActions,
  ...userProductTypesActions,
  ...personalInfoActions,
  ...relationshipManagerActions,
  ...modalActions,
  ...userFundsActions,
  ...RMDactions,
  ...StateWithholdingActions,
  ...RecentTransactionsActions,
  ...QCDHistoryActions,
  ...PaperlessActions
};
